import React from "react";
import { IconType } from "./types";

const Clock: IconType = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M8.41315 3.98122V8.18779L12.0188 10.3286L11.4178 11.3427L7.21127 8.78873V3.98122H8.41315ZM3.4554 12.5446C4.73239 13.7966 6.24726 14.4225 8 14.4225C9.75274 14.4225 11.2551 13.7966 12.507 12.5446C13.784 11.2676 14.4225 9.75274 14.4225 8C14.4225 6.24726 13.784 4.74491 12.507 3.49296C11.2551 2.21596 9.75274 1.57746 8 1.57746C6.24726 1.57746 4.73239 2.21596 3.4554 3.49296C2.20344 4.74491 1.57746 6.24726 1.57746 8C1.57746 9.75274 2.20344 11.2676 3.4554 12.5446ZM2.32864 2.3662C3.9061 0.788732 5.79656 0 8 0C10.2034 0 12.0814 0.788732 13.6338 2.3662C15.2113 3.91862 16 5.79656 16 8C16 10.2034 15.2113 12.0939 13.6338 13.6714C12.0814 15.2238 10.2034 16 8 16C5.79656 16 3.9061 15.2238 2.32864 13.6714C0.776213 12.0939 0 10.2034 0 8C0 5.79656 0.776213 3.91862 2.32864 2.3662Z"
      fill="#999999"
    />
  </svg>
);

export default Clock;
